export default __webpack_public_path__ + "static/media/ic_invoice.f39573fd.png";